import React from "react";
import { componentFromStream } from "recompose";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { getTokensObservable } from "../../utils/authn";
import BannerListItem from "../BannerListItem";

const tokens$ = getTokensObservable();

export default componentFromStream(() => {
  return tokens$.pipe(
    map(() => null),
    catchError(() =>
      of(
        <BannerListItem error>
          Something has gone wrong. Please refresh the page and sign in again.
        </BannerListItem>
      )
    )
  );
});
